<template>
  <span class="viq-confidence" :class="'viq-confidence--' + normalizedLevel">
    <span class="viq-confidence__dot" />
    {{ label }} confidence
  </span>
</template>

<script>
export default {
  name: "ViqConfidenceBadge",
  props: {
    level: {
      type: String,
      required: true,
      validator: (v) => ["high", "medium", "low"].includes(v),
    },
  },
  computed: {
    normalizedLevel() {
      return (this.level || "medium").toLowerCase();
    },
    label() {
      return this.normalizedLevel.charAt(0).toUpperCase() + this.normalizedLevel.slice(1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-confidence {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: $viq-radius-full;
  font-size: $viq-font-xs;
  font-weight: 600;
  margin-bottom: $viq-space-sm;

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  &--high {
    background: rgba(16, 185, 129, 0.1);
    color: $viq-confidence-high;
    .viq-confidence__dot { background: $viq-confidence-high; }
  }

  &--medium {
    background: rgba(245, 158, 11, 0.1);
    color: $viq-confidence-medium;
    .viq-confidence__dot { background: $viq-confidence-medium; }
  }

  &--low {
    background: rgba(239, 68, 68, 0.1);
    color: $viq-confidence-low;
    .viq-confidence__dot { background: $viq-confidence-low; }
  }
}
</style>
